import { axiosAdminApiClient } from "..";
import { handleError } from "../../utils/errors";

class OrdersService {
  createOrder = async (orderData) => {
    try {
      const response = await axiosAdminApiClient.post("/orders", orderData, {
        withCredentials: true,
      });

      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating order");
    }
  };

  getUserOrders = async (page = 1, limit = 10) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      const response = await axiosAdminApiClient.get(`/orders/my?${params}`, {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while getting user orders");
    }
  };

  getOrderById = async (orderId) => {
    try {
      const response = await axiosAdminApiClient.get(`/orders/${orderId}`, {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while getting order");
    }
  };

  // Admin functions
  getAllOrders = async (page = 1, limit = 10, filters = {}, search = "") => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...filters,
      });

      if (search) {
        params.append("search", search);
      }

      const response = await axiosAdminApiClient.get(`/orders?${params}`, {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while getting all orders");
    }
  };

  updateOrderStatus = async (orderId, status) => {
    try {
      const response = await axiosAdminApiClient.put(
        `/orders/${orderId}/status`,
        { status },
        {
          withCredentials: true,
        }
      );

      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating order status");
    }
  };

  addTrackingNumber = async (orderId, trackingNumber) => {
    try {
      const response = await axiosAdminApiClient.put(
        `/orders/${orderId}/tracking`,
        { trackingNumber },
        {
          withCredentials: true,
        }
      );

      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while adding tracking number");
    }
  };

  approveOrder = async (orderId) => {
    try {
      const response = await axiosAdminApiClient.post(
        `/orders/${orderId}/approve`,
        {},
        { withCredentials: true },
      );

      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while approving order");
    }
  };

  getOrderStatistics = async () => {
    try {
      const response = await axiosAdminApiClient.get("/orders/statistics", {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while getting order statistics");
    }
  };
}

const ordersService = new OrdersService();

export default ordersService;